var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"transactionIcon"}},[_c('div',{staticClass:"title-icon text-center"},[_c('div',{staticClass:"fontsize26"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"fontsize24 green"},[_vm._t("main")],2),_vm._v(" "),_c('div',{staticClass:"red"},[_vm._t("note")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5691803b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transaction/transactionIcon.vue
// module id = null
// module chunks = 